import $root from '../../static/proto-bundle';

class BroadcastBuider {

  createStartBroadcastRequest(stream) {
    const builder = $root.lookup('StartBroadcastRequest');
    const streamBuilder = $root.lookup('BroadcastStream');
    const streamPayload = streamBuilder.create(stream);
    const payload = builder.create({stream: streamPayload});
    return builder.encode(payload).finish();
  }

  decode(payload, message) {
    const container = $root.lookup(message);
    return container.decode(new Uint8Array(payload));
  }
}

export default BroadcastBuider;



// WEBPACK FOOTER //
// ./src/services/broadcast-builder.service.js